module.exports = __webpack_public_path__ + "img/level.b130dc4f.svg";